//setCurrentFromTime
export const setCurrentFromTime = (myDate) => {

    //explicitly we are making fromTime to 00:00:00.000Z
    let timeArray = myDate.split("T")
    timeArray[1] = "00:00:00.000Z"
    let currentFromTime = timeArray.join("T")
    return currentFromTime
}